import Card from './components/Card'
import Review from './Review'

export const ReviewCard = Card

export default Review
